import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { collapseCard } from "./style";
import { Button } from "@maxmilhas/hangar-components-atomic/public";
import LinkAsButton from '../LinkAsButton';
import Loading from "../../../../../offers/shared/Loading/Loading";

const CollapseCard = props => {

    const { 
        cardTitle, 
        cardText, 
        collapseText, 
        collapseSmallText, 
        collapseTextHighlight, 
        buttonTextOk, 
        buttonTextCancel, 
        dataAction, 
        onClickOk, 
        onClickCancel, 
        children,
        disabledButton
    } = props;
    const [showDetails, setShowDetails] = useState(false);
    const [disableDoubtLink, setDisableDoubtLink] = useState(true);

    useEffect(() => {
        const interval = window.setInterval(() => {
            if (typeof zE === 'function') {
                const department = zE('webWidget:get', 'chat:department', 2147714291);
                
                if ( department && department.status === 'online') {
                    setDisableDoubtLink(false);
                    window.clearInterval(interval);
                } else if ((department && department.status === 'offline') || (department && department.status === 'away')) {
                    window.clearInterval(interval);
                }
            }
        }, 5000)
    });

    return (
        <div className={css`${collapseCard}`}>
            <div className="collapse-card-header">
                <div className="collapse-card-header__title-wrapper">
                    <h1 className="collapse-card-header__title">{cardTitle}</h1>
                    {/* <LinkAsButton 
                        text="Dúvidas?"
                        icon="icon-max-communication-chat"
                        link="https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=maxmilhas.zendesk.com"
                        target="_blank"
                        tooltipText="Chat indisponível no momento"
                        disabled={disableDoubtLink}
                    /> */}
                </div>
                <p className="collapse-card-header__text">{cardText}</p>
            </div>
            <div className="collapse-card">
                <div className="collapse-card__row">
                    <div className="collapse-card__content">
                        <div className="collapse-card__text">
                            <div>
                                <span>{collapseText}</span>
                            </div>
                            <div><span className="collapse-card__text--highlight">{collapseTextHighlight}</span></div>
                            {collapseSmallText && <div><small>{collapseSmallText}</small></div>}
                        </div>

                        <div className="collapse-card__button">
                            <Button
                                color="green"
                                disabled={!!disabledButton}
                                onClick={onClickOk}
                                size="normal"
                                type="button"
                            >
                                {buttonTextOk}
                            </Button>
                            <Button
                                outline={true}
                                color="#c8ccd4"
                                disabled={false}
                                onClick={onClickCancel}
                                size="normal"
                                type="button"
                            >
                                {buttonTextCancel}
                            </Button>
                        </div>
                    </div>

                    {showDetails && (
                        <>
                            {children}
                            <div
                                className={`collapse-card__details-button ${showDetails ? "opened" : ""}`}
                            >
                                <button
                                    className="btn"
                                    onClick={() => setShowDetails(!showDetails)}
                                    data-action={dataAction}
                                >
                                    <span>Menos detalhes</span>
                                    <i className="icon-arrow-down" />
                                </button>
                            </div>
                        </>
                    )}

                    {!showDetails && (
                        <div
                            className={`collapse-card__details-button ${showDetails ? "opened" : ""}`}
                        >
                            <button
                                className="btn"
                                onClick={() => setShowDetails(!showDetails)}
                                data-action={dataAction}
                            >
                                <span>Ver detalhes</span>
                                <i className="icon-arrow-down" />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CollapseCard
